/**
 * PR-32 — Engagement Celebration Engine.
 * Lightweight celebration trigger: confetti pulse + optional vibration +
 * optional short sound + a localized success message.
 */
import { trackEvent } from "@/lib/audit";

export type CelebrationKind =
  | "poll_correct"
  | "points_won"
  | "coupon_unlocked"
  | "ranking_up"
  | "badge_unlocked";

export const CELEBRATION_MESSAGES: Record<CelebrationKind, string> = {
  poll_correct:    "🎉 ¡Acertaste!",
  points_won:      "👏 Excelente predicción",
  coupon_unlocked: "🎁 Cupón desbloqueado",
  ranking_up:      "👑 Eres Top Fan",
  badge_unlocked:  "🏆 Nuevo logro",
};

export interface CelebrationOptions {
  vibrate?: boolean;
  sound?: boolean;
  durationMs?: number;
}

export function celebrate(kind: CelebrationKind, opts: CelebrationOptions = {}): string {
  const message = CELEBRATION_MESSAGES[kind];
  void trackEvent("celebration_triggered", { kind, message });
  if (opts.vibrate !== false && typeof navigator !== "undefined" && "vibrate" in navigator) {
    try { navigator.vibrate?.([12, 60, 12]); } catch { /* noop */ }
  }
  if (opts.sound && typeof window !== "undefined" && "AudioContext" in window) {
    try {
      const Ctx: typeof AudioContext =
        (window as unknown as { AudioContext: typeof AudioContext }).AudioContext;
      const ac = new Ctx();
      const o = ac.createOscillator();
      const g = ac.createGain();
      o.frequency.value = 880;
      g.gain.value = 0.04;
      o.connect(g).connect(ac.destination);
      o.start();
      setTimeout(() => { o.stop(); ac.close(); }, 140);
    } catch { /* noop */ }
  }
  return message;
}